import { useState } from 'preact/hooks'
import { navigate, useQueryParams } from 'raviger'

import { devLogin } from '../utils/session'

const errorMessages = {
  domain: 'Solo se puede entrar con una cuenta de odderslab.com.',
  state: 'La sesión de Google caducó. Prueba otra vez.',
  google: 'Google no ha respondido bien. Prueba otra vez.'
}

export function Login() {
  const [query] = useQueryParams()
  const message = errorMessages[query.error]

  return (
    <main class="page login">
      <h1>Reto Saludable 2026</h1>
      <p>31 días, un workout al día. Entra con tu cuenta de OddersLab.</p>
      {message && <p class="error">{message}</p>}
      <a class="button primary" href="/auth/google">
        Entrar con Google
      </a>
      {__DEV__ && <DevLogin />}
    </main>
  )
}

function DevLogin() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setError(null)
    try {
      await devLogin(email)
      navigate('/')
    } catch (e) {
      setError(e.code)
    }
  }

  return (
    <form class="dev-login" onSubmit={submit}>
      <p class="muted">Dev login (sin Google)</p>
      <input
        type="email"
        placeholder="nombre@odderslab.com"
        value={email}
        onInput={(e) => setEmail(e.currentTarget.value)}
        required
      />
      <button type="submit">Entrar</button>
      {error && <p class="error">{error}</p>}
    </form>
  )
}
